/* eslint-disable no-useless-escape */
import { LANGUAGE_KEYS } from 'config/languageKeys';

const {
    LOGIN: { SCREEN_USERNAMELFIELD_EMPTY, SCREEN_PASSWORDFIELD_EMPTY },
} = LANGUAGE_KEYS;

export const validateUsername = (username: string) => {
    return username ? '' : SCREEN_USERNAMELFIELD_EMPTY;
};

export const validatePassword = (password: string) => {
    return password ? '' : SCREEN_PASSWORDFIELD_EMPTY;
};
